import queryString from 'query-string';

import Bugsnag from 'lib/bugsnag';
import { fetchWithRetry } from 'shared/helpers/fetchWithRetry';

export async function webToLeadRequest(payload = {}, webToLeadData) {
  const body = queryString.stringify(webToLeadData(payload));
  const response = async () => {
    try {
      await fetchWithRetry(
        process.env.NEXT_PUBLIC_SALESFORCE_WEB_TO_LEAD_ENDPOINT,
        {
          method: 'POST',
          mode: 'no-cors',
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
          },
          body,
          retry: 2,
          pause: 1500,
        }
      );
    } catch (error) {
      Bugsnag.notify(
        new Error(
          `[Error trying to submit Salesforce webToLeadRequest:
            dataFromFunnel: ${JSON.stringify(payload)}
            webToLeadData: ${JSON.stringify(body)}
            error: ${JSON.stringify(error)}`
        )
      );
    }
  };

  return response();
}
